import { i18n } from '@/i18n';

export const filterOptionTypes = [
  {
    index: 0,
    key: 'qName',
    title: i18n.t('message.projectTitle'),
    type: 'text',
    isMultiple: false,
    icon: 'gf-icon gf-icon-folder'
  },
  {
    index: 1,
    key: 'qOwner',
    title: i18n.t('message.ownerTitle'),
    type: 'text',
    isMultiple: false,
    icon: 'gf-icon gf-icon-person'
  }
];

export const maxSelectedFilterOptionsLength = 2;

export const sortingOptionTypes = [
  {
    index: 0,
    key: 'updated_at',
    title: i18n.t('message.updatedAt'),
    defaultDirection: 'ASC'
  },
  {
    index: 1,
    key: 'title',
    title: i18n.t('message.projectTitle'),
    defaultDirection: 'ASC'
  }
];
